import React from 'react';
import termsPdfUrl from '../../../../assets/docs/Termos-de-uso-e-politica-de-privacidade-2024.pdf';
import styles from './TermsPdfViewer.module.css';

const TermsPdfViewer: React.FC = () => (
  <iframe
    className={styles.viewer}
    src={termsPdfUrl}
    title="Termos de uso e Políticas de Privacidade"
    allow="fullscreen"
  />
);

export default TermsPdfViewer;
